import EmblaStyle from '../../styles/EmblaCarousel.module.css';

type Props = {
  selectedIndex: number;
  dataLength: number;
  onClick: (index: number) => void;
};

function DotsButton({ dataLength, selectedIndex, onClick }: Props) {
  return (
    <div className={EmblaStyle.dots}>
      {Array.from({ length: dataLength }).map((_, idx) => (
        <button
          key={`dots-${idx}`}
          type="button"
          aria-label={`Go to slide ${idx + 1}`}
          onClick={() => onClick(idx)}
          className={`
            ${EmblaStyle.dot}
            ${idx === selectedIndex ? EmblaStyle.dotActive : ''}
          `}
        />
      ))}
    </div>
  );
}

export default DotsButton;
